<template>
    <RadioGroup :value="valueComputed" @update:value="onUpdateValue" :disabled="disabled">
        <Radio
            v-for="item in itemsComputed"
            :key="getKeyValue({ record: item, props })"
            :value="getKeyValue({ record: item, props })"
            :class="{ 'd-block text-left ml-1': type === 'vertical', 'mt-2': type === 'vertical' }"
        >
            <component v-if="renderLabel" :is="renderLabel({ item })"></component>
            <span v-else>{{ lodash.get(item, optLabel) }}</span>
        </Radio>
    </RadioGroup>
</template>

<script>
import { computed, defineComponent, onUpdated, reactive } from "vue";
import { Radio } from "ant-design-vue";
import { createReloadItems, createOnUpdateValue, getValues, getItems, getKeyValue } from "./c-radio-group.logic";
import lodash from "lodash";

export default defineComponent({
    components: {
        Radio,
        RadioGroup: Radio.Group
    },
    props: {
        value: {},
        disabled: {},
        list: {},
        optKey: { default: "id" },
        optLabel: { default: "name" },
        renderLabel: {},
        rowKey: {},
        type: {}
    },
    emits: ["update:value"],
    setup(props, { emit }) {
        const data = reactive({ items: [], isLoading: false });
        const reloadItems = createReloadItems({ data, props });
        const onUpdateValue = createOnUpdateValue({ data, props, emit });
        const valueComputed = computed(() => getValues({ props }));
        const itemsComputed = computed(() => getItems({ data, props }));
        reloadItems();
        onUpdated(() => reloadItems());
        return {
            props,
            data,
            emit,
            onUpdateValue,
            valueComputed,
            itemsComputed,
            getKeyValue,
            lodash
        };
    }
});
</script>
